import { useState, useEffect } from "react";
import generarLineaCaptura from "../utilities/GenerarLineaCaptura";
import { generarFolioTPV, construirTablaPdf, descargarOrdenDePago } from "../utilities/ordenDePago";
import { API_BASE, PINPAD_URL } from "../config";
import { asegurarVersionVigente } from "../utilities/versionApp";
import { plantelDeMatricula, idBDDesdePlantel } from "../utilities/plantel";
import { apiFetch } from "../utilities/apiFetch";

const useCarrito = () => {
  const [carrito, setCarrito] = useState([]);
  const [totalCarrito, setTotalCarrito] = useState(0);

  //  NUEVO ESTADO: Control del Modal Emergente de Éxito para Alumnos
  const [modalExito, setModalExito] = useState({
    visible: false,
    nombreAlumno: '',
    monto: 0,
    autorizacion: '',
    referencia: ''
  });

  useEffect(() => {
    const nuevoTotal = carrito.reduce((sum, item) => sum + (item.precio * item.cantidad), 0);
    setTotalCarrito(nuevoTotal);
  }, [carrito]);

  const agregarAlCarrito = (concepto) => {
    setCarrito((prevCarrito) => {
      const totalItems = prevCarrito.reduce((sum, item) => sum + item.cantidad, 0);
      if (totalItems >= 5) {
        alert("Atención: Por reglas del banco, no se pueden cobrar más de 5 conceptos en total.");
        return prevCarrito;
      }

      const clavesPaqueteEgresados = ["50", "51", "52", "53", "54", "55"]; 
      const esPaqueteEgresado = clavesPaqueteEgresados.includes(concepto.clave);
      
      if (esPaqueteEgresado) {
        const paqueteExistente = prevCarrito.find((item) => 
          clavesPaqueteEgresados.includes(item.clave)
        );

        if (paqueteExistente && paqueteExistente.clave !== concepto.clave) {
          alert(`Solo puedes cobrar una opción de Paquete de Egresados a la vez.\nYa tienes "${paqueteExistente.concepto}" en el carrito. Quítalo si deseas agregar este otro.`);
          return prevCarrito; 
        }
      }

      const index = prevCarrito.findIndex((item) => item.id === concepto.id);

      if (index !== -1) {
        const itemActual = prevCarrito[index];
        const nombreConcepto = itemActual.concepto.toLowerCase();
        
        let limitePermitido = 1; 
        
        if (nombreConcepto.includes("examen extraordinario")) {
          limitePermitido = 3;
        } else if (nombreConcepto.includes("curso intersemestral")) {
          limitePermitido = 2;
        } else if (nombreConcepto.includes("diplomas de competencias")) {
          limitePermitido = 5;
        }

        if (itemActual.cantidad >= limitePermitido) {
          alert(`Solo puedes cobrar un máximo de ${limitePermitido} "${itemActual.concepto}" por transacción.`);
          return prevCarrito;
        }

        const nuevoCarrito = [...prevCarrito];
        nuevoCarrito[index] = { ...itemActual, cantidad: itemActual.cantidad + 1 };
        return nuevoCarrito;

      } else {
        return [...prevCarrito, { ...concepto, cantidad: 1 }];
      }
    });
  };

  const quitarDelCarrito = (conceptoId) => {
    setCarrito((prevCarrito) => {
      const index = prevCarrito.findIndex((item) => item.id === conceptoId);
      if (index === -1) return prevCarrito;

      const itemActual = prevCarrito[index];

      if (itemActual.cantidad > 1) {
        const nuevoCarrito = [...prevCarrito];
        nuevoCarrito[index] = { ...itemActual, cantidad: itemActual.cantidad - 1 };
        return nuevoCarrito;
      } else {
        return prevCarrito.filter((item) => item.id !== conceptoId);
      }
    });
  };

  // Ficha PDF de ventanilla (solo para conceptos con permite_pdf, ej. BECA):
  // guarda la referencia pendiente y descarga la misma ficha que el autoservicio.
  const generarFichaPdf = async (alumnoSeleccionado, cajeroId) => {
    if (carrito.length === 0 || !carrito.every((item) => item.permite_pdf)) return;

    const matriculaStr = String(alumnoSeleccionado.matricula);
    const plantelOficialAlumno = plantelDeMatricula(matriculaStr);
    if (!/^\d{2}$/.test(plantelOficialAlumno)) {
      alert("No se pudo identificar el plantel a partir de la matrícula. Verifica el registro del alumno antes de generar la ficha.");
      return;
    }

    const claves = [];
    const conceptosPlano = [];
    carrito.forEach((item) => {
      for (let i = 0; i < item.cantidad; i++) {
        claves.push(item.clave);
        conceptosPlano.push({ clave: item.clave, concepto: item.concepto, precio: item.precio });
      }
    });

    try {
      const infoCaptura = generarLineaCaptura(plantelOficialAlumno, claves, matriculaStr, totalCarrito);
      const folioTPV = generarFolioTPV(idBDDesdePlantel(plantelOficialAlumno));

      const resInt = await fetch(`${API_BASE}/wMultipagosGuardarIntencion.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          codigo_alumno: matriculaStr,
          referencia_banorte: infoCaptura.banorte.lineaDeCaptura,
          referencia_bbva: infoCaptura.bancomer.lineaDeCaptura,
          importe: totalCarrito,
          id_plantel: idBDDesdePlantel(plantelOficialAlumno),
          id_cajero: cajeroId,
          conceptos: conceptosPlano,
          metodo_esperado: "VENTANILLA",
          folio_registro: folioTPV
        })
      });
      const dataInt = await resInt.json();

      if (!dataInt.success) {
        alert("No se pudo guardar la referencia: " + (dataInt.message || "Error desconocido."));
        return;
      }

      await descargarOrdenDePago(
        {
          name: `${alumnoSeleccionado.nombres || ""} ${alumnoSeleccionado.apellido_paterno || ""} ${alumnoSeleccionado.apellido_materno || ""}`.trim() || alumnoSeleccionado.nombre,
          code: matriculaStr,
          table: construirTablaPdf(carrito, infoCaptura, folioTPV),
          folioRegistro: folioTPV,
          fechaVencimiento: infoCaptura.banorte.fechaVencimientoStr,
        },
        `Orden de pago_${matriculaStr}.pdf`
      );

      setCarrito([]);
    } catch (error) {
      console.error("Error al generar la ficha PDF:", error);
      alert("Error al generar la ficha PDF. Revisa tu conexión e intenta de nuevo.");
    }
  };

  const procesarPagoCaja = async (alumnoSeleccionado, cajeroId) => {
    if (carrito.length === 0) return;
    
    let arrayClaves = [];
    carrito.forEach(item => {
      for(let i = 0; i < item.cantidad; i++) {
        arrayClaves.push(item.clave); 
      }
    });

    const matriculaStr = String(alumnoSeleccionado.matricula);
    const plantelOficialAlumno = plantelDeMatricula(matriculaStr);

    if (!/^\d{2}$/.test(plantelOficialAlumno)) {
      alert("No se pudo identificar el plantel a partir de la matrícula. Verifica el registro del alumno antes de cobrar.");
      return;
    }
    const datosReferencia = generarLineaCaptura(
      plantelOficialAlumno, 
      arrayClaves, 
      matriculaStr, 
      totalCarrito
    );

    const sufijoTiempo = Date.now().toString().slice(-4);

    // MODIFICACIÓN: Apuntar a datosReferencia.banorte.referenciaBase
    const referenciaBaseOficial30 = datosReferencia.banorte.referenciaBase 
      ? datosReferencia.banorte.referenciaBase.substring(0, 26) + sufijoTiempo 
      : "";

    // MODIFICACIÓN: Apuntar a datosReferencia.banorte.lineaDeCaptura
    const lineaDeCapturaOficial30 = datosReferencia.banorte.lineaDeCaptura 
      ? datosReferencia.banorte.lineaDeCaptura.substring(0, 26) + sufijoTiempo 
      : "";

    const idPlantelBD = idBDDesdePlantel(plantelOficialAlumno);
    
    const payloadPago = {
      alumno: alumnoSeleccionado.matricula,
      cajero: cajeroId,
      plantel: idPlantelBD,
      total: totalCarrito,
      detalle: carrito,
      lineaCapturaFinal: lineaDeCapturaOficial30, 
      referenciaBase: referenciaBaseOficial30,     
      // MODIFICACIÓN: Apuntar a datosReferencia.banorte.fechaVencimientoStr
      fechaVencimiento: datosReferencia.banorte.fechaVencimientoStr
    };

    const datosPinpadExtra = {
      referenciaPayworks: "", fecha: "", tarjeta: "",
      // Datos del voucher (Anexo VII de Banorte), para el comprobante en pantalla.
      entidad: "", nombreComercio: "", direccion: "", telefono: "", terminalId: "",
      afiliacion: "", tipoTarjeta: "", marcaTarjeta: "", bancoEmisor: "",
      estado: "", validacionPin: "", modoEntrada: "",
      aid: "", tvr: "", appPrefName: "", appLabel: ""
    };

    try {
      // Antes de pasar la tarjeta: si hay una version nueva publicada, no cobrar
      if (!(await asegurarVersionVigente())) return;

      const resTerminal = await fetch(PINPAD_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          Monto: parseFloat(totalCarrito),
          Referencia: referenciaBaseOficial30,
          Concepto: "Pago CECYTEJ"
        })
      });

      const dataTerminal = await resTerminal.json();

      if (dataTerminal.status !== "Aprobado") {
        alert(`El cobro no se procesó.\nMotivo: ${dataTerminal.mensaje}`);
        return;
      }

      payloadPago.autorizacion = dataTerminal.autorizacion;
      // Datos extra que regresa la Pinpad, solo para mostrarlos en pantalla
      // (utiles mientras dure la certificacion con Banorte).
      datosPinpadExtra.referenciaPayworks = dataTerminal.referenciaPayworks || "";
      datosPinpadExtra.fecha = dataTerminal.fecha || "";
      datosPinpadExtra.tarjeta = dataTerminal.tarjeta || "";
      datosPinpadExtra.entidad = dataTerminal.entidad || "";
      datosPinpadExtra.nombreComercio = dataTerminal.nombreComercio || "";
      datosPinpadExtra.direccion = dataTerminal.direccion || "";
      datosPinpadExtra.telefono = dataTerminal.telefono || "";
      datosPinpadExtra.terminalId = dataTerminal.terminalId || "";
      datosPinpadExtra.afiliacion = dataTerminal.afiliacion || "";
      datosPinpadExtra.tipoTarjeta = dataTerminal.tipoTarjeta || "";
      datosPinpadExtra.marcaTarjeta = dataTerminal.marcaTarjeta || "";
      datosPinpadExtra.bancoEmisor = dataTerminal.bancoEmisor || "";
      datosPinpadExtra.estado = dataTerminal.status || "";
      datosPinpadExtra.validacionPin = dataTerminal.validacionPin || "";
      datosPinpadExtra.modoEntrada = dataTerminal.modoEntrada || "";
      datosPinpadExtra.aid = dataTerminal.aid || "";
      datosPinpadExtra.tvr = dataTerminal.tvr || "";
      datosPinpadExtra.appPrefName = dataTerminal.appPrefName || "";
      datosPinpadExtra.appLabel = dataTerminal.appLabel || "";

    } catch (errorTerminal) {
      console.error("Error al comunicar con la terminal local:", errorTerminal);
      alert("Error de conexión con la terminal física. Verifica que la consola de conexión esté iniciada y la terminal conectada.");
      return; 
    }

    try {
      const response = await apiFetch(`${API_BASE}/wMultipagosGuardarPagoCaja.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payloadPago)
      });

      const data = await response.json();

      if (data.success) {
        //  MODIFICADO: En vez de un alert(), disparamos el objeto del modal con sus datos cargados
        setModalExito({
          visible: true,
          nombreAlumno: alumnoSeleccionado.nombre, // Pasamos el nombre para que el cajero esté 100% seguro
          monto: totalCarrito,
          autorizacion: payloadPago.autorizacion,
          referencia: lineaDeCapturaOficial30,
          numeroControl: referenciaBaseOficial30,
          referenciaPayworks: datosPinpadExtra.referenciaPayworks,
          fechaPayworks: datosPinpadExtra.fecha,
          tarjeta: datosPinpadExtra.tarjeta,
          entidad: datosPinpadExtra.entidad,
          nombreComercio: datosPinpadExtra.nombreComercio,
          direccion: datosPinpadExtra.direccion,
          telefono: datosPinpadExtra.telefono,
          terminalId: datosPinpadExtra.terminalId,
          afiliacion: datosPinpadExtra.afiliacion,
          tipoTarjeta: datosPinpadExtra.tipoTarjeta,
          marcaTarjeta: datosPinpadExtra.marcaTarjeta,
          bancoEmisor: datosPinpadExtra.bancoEmisor,
          estado: datosPinpadExtra.estado,
          validacionPin: datosPinpadExtra.validacionPin,
          modoEntrada: datosPinpadExtra.modoEntrada,
          aid: datosPinpadExtra.aid,
          tvr: datosPinpadExtra.tvr,
          appPrefName: datosPinpadExtra.appPrefName,
          appLabel: datosPinpadExtra.appLabel
        });

        setCarrito([]); 
      } else {
        alert("Atención: El banco cobró, pero ocurrió un error en el sistema. " + (data.message || "Error desconocido."));
      }

    } catch (error) {
      console.error("Error al conectar con el servidor:", error);
      alert("Error de conexión al intentar guardar el pago. Revisa tu internet o la consola.");
    }
  };

  return {
    carrito,
    setCarrito,
    totalCarrito,
    agregarAlCarrito,
    quitarDelCarrito,
    procesarPagoCaja,
    generarFichaPdf,
    modalExito,      //  Exportamos el estado del modal
    setModalExito    //  Exportamos el set para poder cerrarlo desde la vista
  };
};

export default useCarrito;